import React from "react";
import { Link } from "react-router-dom"; 

const JobsHeader = () => {
  return (
    <header className="flex justify-between items-end mb-12 w-full max-sm:flex-col max-sm:items-start max-sm:gap-4 max-sm:font-semibold">
      <h1 className="text-5xl leading-[52.8px] max-md:text-4xl max-sm:text-3xl">
        <span className="text-slate-800">Featured</span>
        <span className="text-sky-400">jobs</span>
      </h1>
      <Link
        to="/vacancies" 
        className="flex gap-4 items-center text-base font-semibold text-indigo-600 cursor-pointer max-sm:gap-2 max-sm:hover:px-1 transition-all duration-200"
      >
        <span className="mb-1">Show all jobs</span>
        <div className=""
          dangerouslySetInnerHTML={{
            __html:
              '<svg id="I501:1599;668:14681" layer-name="Icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon" style="width: 24px; height: 24px"> <path d="M19.75 11.7256L4.75 11.7256" stroke="#4640DE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.7002 5.701L19.7502 11.725L13.7002 17.75" stroke="#4640DE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>',
          }}
        />
      </Link>
    </header>
  );
};

export default JobsHeader;
